import {SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const Skeleton = ({ref}: {ref?: React.Ref<HTMLDivElement>}) => {
  return <StyledBlock ref={ref} $width="100%" $height="600px" />;
};

const StyledBlock = styled(SkeletonBlock)`
  flex-shrink: 0;
`;
